/** Hosts that are Tadpole itself; any other host is an org's own domain. */
const TADPOLE_HOSTS = [
  "localhost:3000",
  "www.tadpoletutoring.org",
  "tadpoletutoring.org",
  "www.tadpoletutoring.com",
  "tadpoletutoring.com",
  "www.staging.tadpoletutoring.org",
  "staging.tadpoletutoring.org",
];

export function isWhiteLabelHost(host: string = window.location.host): boolean {
  return !TADPOLE_HOSTS.includes(host.toLowerCase());
}
